import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { AssistantSettingsActions, AssistantSettingsSelectors } from '@core/intelligence-data';

@Injectable({ providedIn: 'root' })
export class HrAssistantSettingsDataService {
  private readonly store = inject(Store);
  private readonly settingsState = this.store.selectSignal(AssistantSettingsSelectors.state);

  public readonly settingsData = this.store.selectSignal(AssistantSettingsSelectors.data);
  public readonly settingsData$ = this.store.select(AssistantSettingsSelectors.data);
  public readonly settingsState$ = this.store.select(AssistantSettingsSelectors.state);

  public fetchSettings() {
    this.store.dispatch(AssistantSettingsActions.fetch());
  }

  public fetchIfNotLoaded() {
    const { pending, loaded } = this.settingsState();
    if (pending || loaded) return;

    this.fetchSettings();
  }
}
